<div class="conteneur" *ngIf="preinscriptions && config; else loader">
  <div class="fx-direction-col">

    @if(config.infoMessage){
    <mat-card appearance="outlined" style="margin: 5px;" [portailCustomStyle]="config.styleCardInfo">
      <div [innerHtml]="config.infoMessage | safe"></div>
    </mat-card>
    }

    <mat-card appearance="raised" *ngFor="let preinsc of preinscriptions" class="card">
      <mat-card-header class="card-header fx-direction-row fx-between-start">
        <mat-card-title class="fx-direction-row fx-start-center">
          <mat-icon style="margin-right: 5px;">person</mat-icon>
          <span>{{ preinsc.nom }} {{ preinsc.prenom }}</span>
        </mat-card-title>
        <mat-card-subtitle class="fx-direction-row fx-start-center" style="margin-left: 5px;">
          <span *ngIf="preinsc.dateDeNaissance !== '0000-00-00'">Né le :
            {{preinsc.dateDeNaissance | date:'shortDate'}}</span>
          <span *ngIf="preinsc.dateAccouchement !== '0000-00-00'">Naissance prévue le :
            {{preinsc.dateAccouchement | date:'shortDate'}}</span>
        </mat-card-subtitle>
        <button mat-mini-fab color="primary" [matMenuTriggerFor]="menu">
          <mat-icon>more_vert</mat-icon>
        </button>
      </mat-card-header>
      <mat-menu #menu="matMenu" xPosition="before">
        <button *ngFor="let formPart of formParts" mat-menu-item
          (click)="openForm(preinsc.idPreInscription, formPart.stepName)">
          <mat-icon color="primary">
            {{ readOnly || (preinsc.decision !== 'En attente' && preinsc.decision !== '') ? 'visibility' : 'edit' }}
          </mat-icon>
          {{ formPart.label }}
        </button>
        <!-- <button mat-menu-item color="primary" routerLink="" *ngIf="permService.hasPermission('preinscription_edit')">
          <mat-icon color="warn">clear</mat-icon>
          Supprimer
        </button> -->
      </mat-menu>
      <mat-card-content style="padding-top: 16px; margin-left: 15px;">
        <div class="line-item">
          <b>Date de la demande : </b>
          {{ preinsc.dateDemande|date:'shortDate' }}
        </div>
        <div class="line-item">
          <b>Période d'inscription : </b>
          <ng-container *ngIf="preinsc.souhaitDateDebut && preinsc.souhaitDateDebut !== '0000-00-00'">
            <span *ngIf="preinsc.souhaitDateFin && preinsc.souhaitDateFin !== '0000-00-00'; else fromDate">
              du {{ preinsc.souhaitDateDebut|date:'shortDate' }} au {{ preinsc.souhaitDateFin|date:'shortDate' }}
            </span>
            <ng-template #fromDate>
              <span>à partir du {{ preinsc.souhaitDateDebut|date:'shortDate' }}</span>
            </ng-template>
          </ng-container>
        </div>
        @if(preinsc.decision === "Acceptée"){
        <div class="line-item">
          <b>Établissement : </b>
          <span>{{preinsc.etablissementRetenu}}</span>
        </div>
        }@else {
        <div class="fx-direction-row fx-wrap line-item">
          <b>Souhait(s) : </b>
          <span>
            <ol class="list-souhaits">
              <li *ngFor="let souhait of preinsc._Souhaits">
                {{souhait._Etablissement.designation}} ({{souhait._Accueil.designation}})</li>
            </ol>
          </span>
        </div>
        }
        @if(preinsc.programmation.length){
        <div class="line-item">
          <b>Jours/horaires : </b>
          <span>
            <ul>
              <ng-template #horaireJour let-jour>
                <li>
                  <span>{{jour.jour | titlecase}} : </span>
                  <ng-container *ngIf="jour.plage1Deb">
                    <span>{{jour.plage1Deb.substring(0, 5)}} à {{jour.plage1Fin.substring(0, 5)}}</span>
                  </ng-container>
                  <ng-container *ngIf="jour.plage2Deb">
                    <span> et {{jour.plage2Deb.substring(0, 5)}} à {{jour.plage2Fin.substring(0, 5)}}</span>
                  </ng-container>
                </li>
              </ng-template>

              @for (entry of preinsc.programmation; track entry[0]) {
              @let key = entry[0];
              @let semaine = entry[1];
              @if(preinsc.programmation.length > 1){
              <li>{{ key }} :</li>
              <ul>
                @for (jour of semaine; track jour) {
                <ng-container *ngTemplateOutlet="horaireJour; context: { $implicit: jour }">
                </ng-container>
                }
              </ul>
              }@else {
              @for (jour of semaine; track jour) {
              <ng-container *ngTemplateOutlet="horaireJour; context: { $implicit: jour }">
              </ng-container>
              }
              }
              }
            </ul>
          </span>
        </div>
        }
        <div class="fx-direction-row fx-wrap fx-start-center fx-gap-2 line-item">
          <b>Statut : </b>
          <app-icon *ngIf="preinsc.decision ==='Refusée'" type="fa" icon="times-circle" class="warn" size="18">
          </app-icon>
          <app-icon *ngIf="preinsc.decision ==='Acceptée'" type="fa" icon="check-circle" class="primary" size="18">
          </app-icon>
          <app-icon *ngIf="preinsc.decision ==='Abandon'" type="fa" icon="trash" size="18"></app-icon>
          <app-icon *ngIf="preinsc.decision ==='En attente'" type="fa" icon="question-circle" class="accent"
            size="18"></app-icon>
          <app-icon *ngIf="preinsc.decision ===''" type="fa" icon="question-circle" class="accent" size="18">
          </app-icon>
          <span>{{ preinsc.decision || 'En attente'}}</span>
        </div>

        @if(preinsc.decision === 'Refusée' || preinsc.decision === 'Abandon'){
        <div class="line-item">
          <b>Motif : </b>
          @if(preinsc.motifRefus){
          <span>{{preinsc.motifRefus}}</span>
          }
          @if(preinsc.motifAbandon){
          <span>{{preinsc.motifAbandon}}</span>
          }
        </div>
        }
      </mat-card-content>
      @if(config.enabledConfirmation && (preinsc.decision === "" || preinsc.decision ==='En attente')){
      <mat-card-actions align="end">
        @if(!preinsc.dateConfirmation){
        <button color="primary" mat-raised-button (click)="onConfirmButton(preinsc)" [disabled]="preinsc._isLoaded">

          <div class="fx-direction-row fx-align-item-center fx-gap-5">
            @if (preinsc._isLoaded) {
            <mat-progress-spinner mode="indeterminate" strokeWidth="2" diameter="18"
              color="accent"></mat-progress-spinner>
            }
            <span>{{'mikado.preinscriptions.text_confirmation_button' | trans}}</span>
          </div>

        </button>
        }@else {
        <i>Confirmée le <span style="font-weight: 500;">{{preinsc.dateConfirmation | date:'shortDate'}}</span></i>
        }

      </mat-card-actions>
      }
    </mat-card>

    <mat-card appearance="outlined" *ngIf="permToCreate" class="card card-add">
      <mat-card-header class="card-header fx-direction-row fx-center-center">
        <mat-card-title class="fx-direction-row fx-center-center">
          Nouvelle pré-inscription
        </mat-card-title>
      </mat-card-header>
      <mat-card-content style="margin-top: 20px;" class="fx-direction-row fx-center-center">
        <button mat-fab color="primary" matTooltip="Nouvelle pré-inscription" [disabled]="!addBtnUrl"
          [routerLink]="addBtnUrl">
          <mat-icon>add</mat-icon>
        </button>
      </mat-card-content>
    </mat-card>

  </div>

  <div *ngIf="!preinscriptions.length && readOnly">
    <h2 style="text-align: center;">Vous n'avez pas de pré-inscription(s).</h2>
  </div>
</div>

<ng-template #loader>
  <app-loader [message]="'Chargement des données...'" class="margin"></app-loader>
</ng-template>